import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { HeaderService } from 'src/app/header/header.service';
import { notificationsCardCollapseAnimation } from 'src/app/animations/notifications-card-collapse';
import { NotificationsService } from 'src/app/services/notifications-services/notifications.service';
import { APP_CONFIG } from 'src/app/config';

@Component({
  selector: 'app-header-notifications-dropdown',
  templateUrl: './header-notifications-dropdown.component.html',
  styleUrls: ['./header-notifications-dropdown.component.scss'],
  animations: [notificationsCardCollapseAnimation]
})
export class HeaderNotificationsDropdownComponent implements OnInit {

  public show: boolean;
  private headerComponents: Array<any>;
  notifications;

  constructor(private eRef: ElementRef,
              private headerService: HeaderService,
              private notificationsService: NotificationsService) {
                this.notifications = [];
  }

  ngOnInit() {
    this.headerService.setAsHeaderComponent(this);
    this.headerService.listen().subscribe(
      (res) => {
        this.headerComponents = res;
        this.headerComponents.forEach(
          (e) => {
            if (e['component'] === this) {
              this.show = e['show'];
            }
          }
        );
      }
    );
    this.notificationsService.listenNotifications().subscribe(
      (res) => {
        this.notifications = res;
      }
    );
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if ((!this.eRef.nativeElement.contains(event.target)) && (this.show)) {
      this.toggle();
    }
  }

  public toggle() {
    this.headerService.toggle(this);
  }

  public doAction(action) {
    eval(action);
  }
}
